<div class="shop-contact-form-container">
  <div class="content" [formGroup]="form">
    <kion-input
      id="email-input"
      controlName="email"
      [invalid]="email.invalid && (email.dirty || email.touched)"
      [label]="'forms.address.email.label' | translate"
      [placeHolder]="'forms.address.email.placeHolder' | translate"
      [form]="form" >
      <ng-container *ngIf="email.invalid && (email.dirty || email.touched)">
        <p class="error" *ngIf="email.errors.email">
          {{ 'forms.email.regEx' | translate }}
        </p>
        <p class="error" *ngIf="email.errors.required">
          {{ 'forms.required' | translate }}
        </p>
      </ng-container>
    </kion-input>
    <kion-input
      id="name-input"
      controlName="name"
      [invalid]="name.invalid && (name.dirty || name.touched)"
      [label]="'forms.address.name.label' | translate"
      [placeHolder]="'forms.address.name.placeHolder' | translate"
      [form]="form" >
      <ng-container *ngIf="name.invalid && (name.dirty || name.touched)">
        <p class="error" *ngIf="name.errors.required">
          {{ 'forms.required' | translate }}
        </p>
        <p class="error" *ngIf="name.errors.maxlength">
          {{ 'forms.maxLength' | translate }}
        </p>
        <p class="error" *ngIf="name.errors.minlength">
          {{ 'forms.maxLength' | translate }}
        </p>
      </ng-container>
    </kion-input>
    <kion-input
      id="phone-input"
      controlName="phone"
      [invalid]="phone.invalid && (phone.dirty || phone.touched)"
      [label]="'forms.address.phone.optionalLabel' | translate"
      [placeHolder]="'forms.address.phone.placeHolder' | translate"
      [form]="form" >
      <ng-container *ngIf="phone.invalid && (phone.dirty || phone.touched)">
        <p class="error" *ngIf="phone.errors.maxlength">
          {{ 'forms.maxLength' | translate }}
        </p>
        <p class="error" *ngIf="phone.errors.minlength">
          {{ 'forms.minLength' | translate }}
        </p>
      </ng-container>
    </kion-input>
    <kion-select
      [hidden]="this.subject"
      [options]="requestProperties"
      id="select-request"
      controlName="request"
      [invalid]="request.invalid && (request.dirty || request.touched)"
      [label]="'forms.contact.requestLabel' | translate"
      [placeHolder]="'forms.contact.requestPlaceHolder' | translate"
      [form]="form" >
      <ng-container *ngIf="request.invalid && (request.dirty || request.touched)">
        <p class="error" *ngIf="request.errors.required">
          {{ 'forms.required' | translate }}
        </p>
      </ng-container>
    </kion-select>
    <kion-text-area
      id="message-input"
      controlName="message"
      [invalid]="message.invalid && (message.dirty || message.touched)"
      [label]="'forms.address.message.label' | translate"
      [placeHolder]="'forms.address.message.placeHolder' | translate"
      [form]="form" >
      <ng-container *ngIf="message.invalid && (message.dirty || message.touched)">
        <p class="error" *ngIf="message.errors.required">
          {{ 'forms.required' | translate }}
        </p>
        <p class="error" *ngIf="message.errors.minlength">
          {{ 'forms.minLength' | translate }}
        </p>
        <p class="error" *ngIf="message.errors.maxlength">
          {{ 'forms.maxLength' | translate }}
        </p>
      </ng-container>
    </kion-text-area>
    <div class="required-description">
      {{ 'forms.contact.required.description' | translate }}
    </div>
  </div>
</div>
